(function () {
    "use strict";

    var serviceId = "userSvc";

    angular.module("app.security").factory(serviceId, userSvc);

    userSvc.$inject = [
        "$rootScope",
        "$q",
        "$window",
        "auth_factory",
        "user_factory",
        "appActivitySvc",
        "notifierSvc",
        "ngDialog",
        "$timeout",
        "$translate",
        "$state",
        "leadAPI",
        "user_info",
        "$ocLazyLoad",
        "restoreUrlService",
        "$interval",
        "$cookies",
        "CacheFactory",
        "notificationService",
        "orders_factory",
        "mcpService"
    ];

    function userSvc(
        $rootScope,
        $q,
        $window,
        auth_factory,
        user_factory,
        appActivitySvc,
        notifierSvc,
        ngDialog,
        $timeout,
        $translate,
        $state,
        leadAPI,
        user_info,
        $ocLazyLoad,
        restoreUrlService,
        $interval,
        $cookies,
        CacheFactory,
        notificationService,
        orders_factory,
        mcpService
    ) {
        var service = {
            signIn: signIn,
            registerAndLogin: registerAndLogin,
            signInExternal: signInExternal,
            signInEmlakjet: signInEmlakjet,
            externalLoginConfirm: externalLoginConfirm,
            signOut: signOut,
            hardDelete: hardDelete,
            setUser: setUser,
            changePassword: changePassword,
            getUserInfo: getUserInfo,
            checkEmail: checkEmail,
            register: register,
            signInWithTokenResult: signInWithTokenResult,
            passwordStatus: passwordStatus,
            refreshClientId: refreshClientId,
            updateAvatar: updateAvatar,
            postCertFile: postCertFile,
            info: {
                Id: "",
                Email: "",
                AccessToken: "",
                Role: null,
                Products: [],
                SignedIn: false,
                Details: {
                    "email": null,
                    "phoneNumber": null,
                    "language": $window.langCode(),
                    "profile": {
                        "name": "",
                        "surName": "",
                        "avatarUrl": "",
                        "logoUrl": "",
                        "officeName": "",
                        "slogan": "",
                        "userType": 10,
                        // "RegisterReason": 10,
                        "useDarkMode": 1,
                        "companyId": null,
                        "registrationDate": null,
                        "lastLoginDate": null
                    },
                    "permissions": [],
                    // "registerReason": 10
                },
                TerminalProducts: []
            },
            finger_info: {
                // finger: null, //CACHING IMPLEMENTED
                prints: {}
            },
            upscopeInit: false,
            wootricInit: false,
            SendConfirmationEmail: SendConfirmationEmail,
            ConfirmEmail: ConfirmEmail,
            SendForgotPasswordEmail: SendForgotPasswordEmail,
            ResetPassword: ResetPassword,
            NewPassword: NewPassword,
            refresh: refresh,
            getLastLogins: getLastLogins,
            getLastFailedLogins: getLastFailedLogins,
            getLastSuccessLogins: getLastSuccessLogins,
            lastResult: null,
            setFingerLimit: setFingerLimit,
            getFingerLimit: getFingerLimit,
            getFinger: getFinger,
            refreshProducts: refreshProducts,
            setGA4UserProperties: setGA4UserProperties,
            ga4UserInfo: {
                user_type: null,
                user_register_reason: null,
                user_package: null,
                user_edr_count_konut: null,
                user_edr_count_arazi: null,
                user_edr_count_ticari: null,
                user_edr_count_arsa: null
            }
        };


        function refreshProducts() {
            var deferred = $q.defer();
            orders_factory.myProducts().$promise.then(function (response) {
                if (response && response.products) {
                    service.info.Products = response.products;
                    service.info.TerminalProducts = response.terminalProducts || [];
                }
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function refreshClientId(clickId, clientId, sessionId, sessionNumber) {
            let payload = {
                googleClickId: clickId,
                googleClientId: clientId,
                googleSessionId: sessionId,
                googleSessionNumber: sessionNumber,
                sending: false
            };
            if (window.gclid && (!clickId || window.gclid !== clickId)) {
                payload.googleClickId = window.gclid;
                payload.sending = true;
            }
            if (window.gaclient && (!clientId || window.gaclient !== clientId)) {
                payload.googleClientId = window.gaclient;
                payload.sending = true;
            }
            if (window.gasessionId && (!sessionId || window.gasessionId !== sessionId)) {
                payload.googleSessionId = window.gasessionId;
                payload.sending = true;
            }
            if (window.gasessionNumber && (!sessionNumber || window.gasessionNumber !== sessionNumber)) {
                payload.googleSessionNumber = window.gasessionNumber;
                payload.sending = true;
            }

            if (payload.sending)
                user_factory.refreshClientId(payload).$promise.then(function (result) {
                    CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                });
        }

        function updateAvatar(img) {
            var deferred = $q.defer();
            img.dst = $window.compressBase64Image(img.dst);
            var base64Data = img.dst.substr(img.dst.indexOf('base64,') + 'base64,'.length);
            user_factory.upload_avatar({ b64S: base64Data }).$promise.then(function (result) {
                CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                CacheFactory.get('Agents') && CacheFactory.get('Agents').removeAll();
                CacheFactory.get('AgentsGet') && CacheFactory.get('AgentsGet').removeAll();
                CacheFactory.get('AgentsSearch') && CacheFactory.get('AgentsSearch').removeAll();

                service.info.Details.profile.avatarUrl = result.savedUrl;
                deferred.resolve(service.info);
                notifierSvc.show({ message: $translate.instant('account_success'), type: "success" });
            }, function (response) {
                deferred.reject(response);
                if (response.data.detail && response.data.detail.includes('Profile picture can only be a photo')) {
                    notifierSvc.show({ message: $translate.instant('profile_avatar_error'), type: 'error' });
                } else {
                    notifierSvc.show({ message: response.data.detail ? response.data.detail : response.data.title, type: 'error' });
                }
            });
            return deferred.promise;
        }

        function postCertFile(file, certificate) {
            var deferred = $q.defer();
            var base64Data = file.src.substr(file.src.indexOf('base64,') + 'base64,'.length);
            user_factory.upload_certificate({ b64S: base64Data, userId: service.info.Id, fileExtention: file.mime }).$promise.then(function (result) {
                certificate.url = result.savedUrl;
                user_factory.submit_certificates({
                    userId: { value: service.info.Id },
                    userCertificateList: [certificate]
                }).$promise.then(function (response) {
                    CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                    CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                    CacheFactory.get('Agents') && CacheFactory.get('Agents').removeAll();
                    CacheFactory.get('AgentsGet') && CacheFactory.get('AgentsGet').removeAll();
                    CacheFactory.get('AgentsSearch') && CacheFactory.get('AgentsSearch').removeAll();
                    //notifierSvc.show({ message: $translate.instant('account_success'), type: "success" });
                    deferred.resolve(certificate);
                }, function (err) {
                    notifierSvc.show({ message: err.data.detail ? err.data.detail : err.data.title, type: 'error' });
                    deferred.reject(err);
                }).finally(function () {
                    certificate = null;
                    file = null;
                });
            }, function (response) {
                notifierSvc.show({ message: response.data.detail ? response.data.detail : response.data.title, type: 'error' });
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function checkEmail(email) {
            var deferred = $q.defer();
            if (!email) {
                deferred.resolve({ result: true, status: 200 });
                return;
            }
            $.ajax({
                url: "https://api.email-validator.net/api/verify",
                type: "POST",
                cache: false,
                crossDomain: true,
                data: {
                    EmailAddress: email,
                    APIKey: "ev-45ed540646071ea3e34158619594088f",
                },
                dataType: "json",
                success: function (json) {
                    deferred.resolve(json);
                },
            });

            return deferred.promise;
        }

        function setGA4UserProperties() {
            if (service.info.SignedIn) {
                let user = service.lastResult;
                let registerReasons = [
                    { val: 10, name: 'Satmak İstiyorum' },
                    { val: 20, name: 'Kiraya Vereceğim' },
                    { val: 30, name: 'Almak İstiyorum' },
                    { val: 40, name: 'Kiralayacağım' },
                    { val: 50, name: 'Değerini Merak Ediyorum' },
                    { val: 60, name: 'Kirasını Merak Ediyorum' },
                    { val: 70, name: 'Sadece Değerine/Kirasına Bakacağım' }
                ];

                let userPropertiesObject = angular.copy(service.ga4UserInfo);

                userPropertiesObject = Object.assign(userPropertiesObject, {
                    user_type: user.isAgent ? 'Danışman' : 'Bireysel',
                    user_register_reason: registerReasons.find((r) => r.val === user.information.registerReason) ? registerReasons.find((r) => r.val === user.information.registerReason).name : null,
                    user_package: null
                });

                angular.forEach(user.products, (p) => {
                    if (p.code.indexOf('edr-') !== -1) {
                        if (p.code.indexOf('house') !== -1)
                            userPropertiesObject['user_edr_count_konut'] = p.count;
                        else if (p.code.indexOf('commercial') !== -1)
                            userPropertiesObject['user_edr_count_ticari'] = p.count;
                        else if (p.code.indexOf('plot') !== -1)
                            userPropertiesObject['user_edr_count_arsa'] = p.count;
                        else if (p.code.indexOf('land') !== -1)
                            userPropertiesObject['user_edr_count_arazi'] = p.count;
                    }

                    if (p.productType === 20 || p.productType === 40) {
                        userPropertiesObject['user_package'] = p.nameTurkish;
                    }
                });

                window.localStorage.setItem('ga4_user_properties', JSON.stringify(userPropertiesObject));
            } else {
                window.localStorage.setItem('ga4_user_properties', JSON.stringify(service.ga4UserInfo));
            }

        }

        var userInfo;
        var get_user_info = false;
        function setUser(user) {
            appActivitySvc.busy("userSvc");
            if (user) {
                if (!get_user_info) {
                    get_user_info = true;
                    service.info.Email = user.information.email;
                    service.info.SignedIn = true;
                    service.info.Id = user.information.id.value;
                    service.info.Role = user.information.role;
                    service.info.Products = user.products;
                    service.info.TerminalProducts = user.terminalProducts;
                    // user.information.profile.RegisterReason = service.info.Details.profile.RegisterReason;
                    service.info.Details = angular.copy(user.information);
                    $rootScope.recommendedFieldsToFill = user.information.recommendedFieldsToFill;

                    if ($window.dengage) {
                        $window.dengage("setContactKey", user.information.id.value.toUpperCase());
                        $window.dengage('setTrackingPermission', true);
                    }

                    if ($window.Upscope && !service.upscopeInit) {
                        $window.Upscope("init", {
                            uniqueId: user.information.id.value,
                            identities: [
                                user.information.profile.name + ' ' + user.information.profile.surName,
                                user.information.email,
                                user.information.role,
                                user.products.map(function (x) {
                                    return x.code;
                                }).toString()
                            ],
                        });
                        service.upscopeInit = true;
                    }

                    if (typeof $window.Ybug !== "undefined")
                        $window.Ybug.setUser({
                            id: user.information.id.value,
                            username: user.information.profile.name + ' ' + user.information.profile.surName,
                            email: user.information.email,
                            phone: user.information.phoneNumber,
                            products: user.products.map(function (x) {
                                return x.code;
                            }).toString()
                        });
                    else if (typeof $window.ybug_settings !== "undefined") {
                        $window.ybug_settings.user = {};
                        $window.ybug_settings.user.id = user.information.id.value;
                        $window.ybug_settings.user.username = user.information.profile.name + ' ' + user.information.profile.surName;
                        $window.ybug_settings.user.email = user.information.email;
                        $window.ybug_settings.user.phone = user.information.phoneNumber;
                        $window.ybug_settings.user.products = user.products.map(function (x) {
                            return x.code;
                        }).toString();
                    }

                    if (typeof $window.TrackJS !== "undefined")
                        $window.TrackJS.configure({
                            userId: user.information.email,
                            version: $window.appVersion
                        });


                    const langIso = window.langIso(user.information.language);

                    document.tidioChatLang = langIso === 'pt-PT' ? 'pt' : langIso === 'es-ES' ? 'es' : langIso;
                    document.tidioIdentify = {
                        distinct_id: user.information.id.value, // Unique visitor ID in your system
                        email: user.information.email, // visitor email
                        name: user.information.profile.name + ' ' + user.information.profile.surName, // Visitor name
                        phone: user.information.phoneNumber //Visitor phone
                    };

                    if (typeof $window.tidioChatApi !== 'undefined') {
                        $window.tidioChatApi.setVisitorData({
                            distinct_id: user.information.id.value, // Unique visitor ID in your system
                            email: user.information.email, // visitor email
                            name: user.information.profile.name + ' ' + user.information.profile.surName, // Visitor name
                            phone: user.information.phoneNumber
                        });
                    }
                    if (userInfo)
                        userInfo.$cancelRequest();

                    userInfo = user_info.get({ userid: user.information.id.value });
                    userInfo.$promise.then(function (result) {
                        if (typeof $window.Beamer !== 'undefined') {
                            $window.Beamer.update({
                                product_id: "ETrLZbwu14939",
                                selector: ".beamer",
                                language: $window.lang.toUpperCase(),
                                lazy: true,
                                user_firstname: user.information.profile.name,
                                user_lastname: user.information.profile.surName,
                                user_email: user.information.email,
                                user_id: user.information.id.value,
                                user_phone: user.information.phoneNumber,
                                package_name: result.PackageName,
                                previous_package_name: result.PreviousPackageName,
                                total_valuation: result.TotalValuation,
                                user_type: result.UserTypeDesc,
                                office_name: user.information.profile.officeName
                            });
                        }

                        window.gclid = localStorage.getItem('gclid') || undefined;
                        window.gaclient = localStorage.getItem('gaclient') || undefined;


                        if (typeof $window.tidioChatApi !== 'undefined') {
                            $window.tidioChatApi.setContactProperties({
                                office_name: user.information.profile.officeName,
                                package_create_date: moment(result.PackageCreateDate).format("DD.MM.YYYY"),
                                package_expire_date: moment(result.PackageExpireDate).format("DD.MM.YYYY"),
                                package_name: result.PackageName,
                                previous_package_name: result.PreviousPackageName,
                                create_date: moment(result.RegistrationDate).format("DD.MM.YYYY"),
                                seller_name: result.SellerName,
                                this_month_valuation: result.ThisMonthValuation,
                                last_month_valuation: result.LastMonthValuation,
                                commercial_valuation: result.TotalCommercialValuation,
                                house_valuation: result.TotalHouseValuation,
                                plot_valuation: result.TotalPlotValuation,
                                land_valuation: result.TotalLandValuation,
                                total_valuation: result.TotalValuation,
                                user_type: result.UserTypeDesc,
                                gclid: window.gclid,
                                gaclient: window.gaclient
                            });
                            if ($window.Upscope && !service.upscopeInit)
                                $window.Upscope('getWatchLink', function (link) {
                                    $window.tidioChatApi.setContactProperties({
                                        screen_share: link
                                    });
                                });
                        }
                        if (typeof $window.wootric !== 'undefined' && !service.wootricInit) {
                            $window.wootricSettings = {
                                email: user.information.email,
                                phone_number: user.information.phoneNumber,
                                external_id: user.information.id.value,
                                created_at: moment(user.information.profile.registrationDate).unix(),
                                account_token: "NPS-66c1ee71",
                                product_name: "Endeksa",
                                twitter_account: window.lang === 'es-ES' ? 'endeksa_es' : window.lang === 'pt-PT' ? 'endeksa_pt' : 'endeksa',
                                facebook_page: 'https://www.facebook.com/endeksa',
                                language: window.lang === 'pt-PT' ? 'PT_PT' : window.lang.split('-')[0].toUpperCase(),
                                ask_permission_to_share_feedback: true,
                                // scale_color: "gradient",
                                permission_labels: {
                                    EN: "I give permission to share my feedback on Endeksa's website and social media channels.",
                                    TR: "Endeksa'nın web sitesi ve sosyal medya kanallarında geri bildirimlerimi paylaşmasına izin veriyorum.",
                                    PT_PT: "Eu dou permissão para compartilhar meu feedback nos canais de mídia social e no site da Endeksa.",
                                    ES: "Doy permiso para compartir mis comentarios en los canales de redes sociales y en el sitio web de Endeksa."
                                },
                                properties: {
                                    name: user.information.profile.name + ' ' + user.information.profile.surName,
                                    office: user.information.profile.officeName,
                                    language: window.lang,
                                    role: result.UserTypeDesc,
                                    pricing_plan: result.PackageName,
                                    // total_purchase_amount: 12,
                                    last_order_date: moment(result.PackageCreateDate).unix(),
                                    items_array: result.TotalValuation,
                                }
                            };
                            service.wootricInit = true;
                            $window.wootric("run");
                        }
                        $cookies.put('login_status', true);
                        get_user_info = false;
                    });
                    appActivitySvc.idle("userSvc");
                    raiseEvent();
                }
            } else {
                $window.localStorage.removeItem("accessToken");
                $window.localStorage.removeItem("accessTokenExpires");
                $window.localStorage.removeItem("refreshToken");
                $window.localStorage.removeItem("refreshTokenExpires");
                $window.localStorage.removeItem("Endeks");
                $cookies.put('login_status', false);

                service.info.SignedIn = false;
                service.info.Role = null;
                service.info.Products = [];
                service.info.Permissions = [];
                service.info.Id = null;
                service.info.Details = {
                    "email": null,
                    "phoneNumber": null,
                    "language": $window.langCode(),
                    "profile": {
                        "name": "",
                        "surName": "",
                        "avatarUrl": "",
                        "logoUrl": "",
                        "officeName": "",
                        "slogan": "",
                        "userType": 10,
                        // "RegisterReason": 10,
                        "useDarkMode": 1,
                        "companyId": null,
                        "registrationDate": null,
                        "lastLoginDate": null
                    },

                    "permissions": [],
                    // "registerReason": 10
                };
                service.lastResult = null;

                // if (
                //     typeof $window.Intercom !== "undefined"
                // )
                //     $window.Intercom("shutdown");

                appActivitySvc.idle("userSvc");
                raiseEvent();
            }
            service.setGA4UserProperties();
        }

        function getLastLogins() {
            var deferred = $q.defer();
            user_factory.last_logins().$promise.then(function (response) {

                var successLogins = response.succesfulLogins.map(function (login) {
                    login.loginDate = moment(login.loginDate).utcOffset(+6).format('D.M.Y HH:mm:ss');
                    login.status = 'success';
                    return login;
                });
                var failedLogins = response.unSuccesfulLogins.map(function (login) {
                    login.loginDate = moment(login.loginDate).utcOffset(+6).format('D.M.Y HH:mm:ss');
                    login.status = 'failed';
                    return login;
                });

                var logins = successLogins.concat(failedLogins);

                logins = logins.slice().sort(function (a, b) {
                    return b.loginDate.localeCompare(a.loginDate);
                });

                deferred.resolve(logins);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function getLastFailedLogins() {
            var deferred = $q.defer();
            user_factory.last_logins().$promise.then(function (response) {

                var failedLogins = response.unSuccesfulLogins.map(function (login) {
                    login.loginDate = moment(login.loginDate).utcOffset(+6).format('D.M.Y HH:mm:ss');
                    login.status = 'failed';
                    return login;
                });

                deferred.resolve(failedLogins);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function getLastSuccessLogins() {
            var deferred = $q.defer();
            user_factory.last_logins().$promise.then(function (response) {

                var successLogins = response.succesfulLogins.map(function (login) {
                    login.loginDate = moment(login.loginDate).utcOffset(+6).format('D.M.Y HH:mm:ss');
                    login.status = 'success';
                    return login;
                });

                deferred.resolve(successLogins);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function signIn(user, isCampaign) {
            appActivitySvc.busy("userSvc");
            var deferred = $q.defer();
            auth_factory
                .login2fa(user)
                .$promise
                .then(
                    function (result) {
                        //isCampaign && restart password
                        if (isCampaign && result && (result.token || result.verificationToken)) {
                            var success = $translate.instant('email_forgot_pwd');
                            window.alert(success);
                            // notifierSvc.show({ message: success, type: "success" });
                            SendForgotPasswordEmail(result.email);
                        }
                        if (result && result.token) {
                            $window.localStorage.setItem("accessToken", result.token.accessToken);
                            $window.localStorage.setItem("accessTokenExpires", result.token.accessTokenExpiration);
                            $window.localStorage.setItem("refreshToken", result.token.refreshToken);
                            $window.localStorage.setItem("refreshTokenExpires", result.token.refreshTokenExpiration);
                            notificationService.purgeCache();
                            notificationService.getNotifications();
                            getUserInfo(null, true).then(function () {
                                deferred.resolve(result);
                                restoreUrlService.returnTo(false);
                            }, function (reject) {
                                deferred.reject();
                                notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "warning" });
                            });
                        }
                        else if (result && result.verificationToken) {
                            $window.localStorage.setItem("2faPhone", result.phone);
                            $window.localStorage.setItem("2faMail", result.email);
                            $window.localStorage.setItem("verificationToken", result.verificationToken);
                            $window.localStorage.setItem("verificationTokenExpiration", result.verificationTokenExpiration);
                            $window.localStorage.setItem("verificationTokenCreatedAt", result.serverTime);
                            $state.go("code", { langcode: $window.lang || "en" });
                            deferred.resolve();
                        } else {
                            deferred.reject();
                        }
                    },
                    function (reject) {
                        if (reject.data.detail && reject.data.detail.indexOf('has not been confirmed') > -1)
                            $state.go("confirmEmail", { langcode: $window.lang || "en", email: user.email });
                        else if (!isCampaign) {
                            if (reject.data.detail && reject.data.detail.includes('password is incorrect')) {
                                notifierSvc.show({ message: $translate.instant('password_incorrect'), type: "warning" });
                            } else {
                                notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "warning" });
                            }
                        }
                        else {
                            notifierSvc.show({ message: $translate.instant('campaign_not_found'), type: "warning" });
                        }

                        deferred.reject(reject);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });

            return deferred.promise;
        }
        function registerAndLogin(user) {
            appActivitySvc.busy("userSvc");
            var deferred = $q.defer();
            user.language = $window.langCode();
            auth_factory
                .registerandlogin(Object.assign(user, { captchaTokenCustom: window.ecSec() }))
                .$promise
                .then(
                    function (result) {
                        if (result && result.token) {
                            $window.localStorage.setItem("accessToken", result.token.accessToken);
                            $window.localStorage.setItem("accessTokenExpires", result.token.accessTokenExpiration);
                            $window.localStorage.setItem("refreshToken", result.token.refreshToken);
                            $window.localStorage.setItem("refreshTokenExpires", result.token.refreshTokenExpiration);
                            notificationService.purgeCache();
                            notificationService.getNotifications();
                            getUserInfo(null, true).then(function () {
                                deferred.resolve(result);
                                restoreUrlService.returnTo(false);
                            }, function (reject) {
                                deferred.reject();
                                // notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "warning" });
                            });
                        }
                        else if (result && result.verificationToken) {
                            $window.localStorage.setItem("2faPhone", result.phone);
                            $window.localStorage.setItem("2faMail", result.email);
                            $window.localStorage.setItem("verificationToken", result.verificationToken);
                            $window.localStorage.setItem("verificationTokenExpiration", result.verificationTokenExpiration);
                            $window.localStorage.setItem("verificationTokenCreatedAt", result.serverTime);
                            $state.go("code", { langcode: $window.lang || "en" });
                            deferred.resolve();
                        } else {
                            deferred.reject();
                        }
                    },
                    function (reject) {
                        if (reject.data.detail && reject.data.detail.indexOf('has not been confirmed') > -1)
                            $state.go("confirmEmail", { langcode: $window.lang || "en", email: user.email });

                        deferred.reject(reject);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });

            return deferred.promise;
        }

        function signInWithTokenResult(result) {
            var deferred = $q.defer();

            if (result && result.token) {
                $window.localStorage.setItem("accessToken", result.token.accessToken);
                $window.localStorage.setItem("accessTokenExpires", result.token.accessTokenExpiration);
                $window.localStorage.setItem("refreshToken", result.token.refreshToken);
                $window.localStorage.setItem("refreshTokenExpires", result.token.refreshTokenExpiration);
                notificationService.purgeCache();
                notificationService.getNotifications();
                getUserInfo(null, true).then(function () {
                    deferred.resolve(result);
                    restoreUrlService.returnTo(false);
                }, function (reject) {
                    deferred.reject(reject);
                    notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "warning" });
                });
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function hardDelete() {
            appActivitySvc.busy("userSvc");
            var deferred = $q.defer();
            user_factory
                .delete()
                .$promise
                .then(
                    function () {
                        $ocLazyLoad.load([
                            'https://apis.google.com/js/platform.js'
                        ]).then(function () {
                            gapi.load('auth2', function () {
                                var auth2 = gapi.auth2.getAuthInstance();
                                if (auth2)
                                    auth2.signOut().then(function () {
                                        auth2.disconnect();
                                    });
                            });
                        });
                        CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                        CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                        window.endeksa = null;
                        service.setUser();
                        var stateKeys = ['tidio_state_PK', 'tidio_state_j5alrjdajkdksb5lhqle6ssooanm9dgf'];
                        stateKeys.forEach(function (stateKey) {
                            var state = JSON.parse(localStorage.getItem(stateKey));
                            if (state)
                                $window.localStorage.setItem(stateKey, JSON.stringify({}));
                        });
                        deferred.resolve();
                    },
                    function (reject) {
                        deferred.reject(reject);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            return deferred.promise;
        }

        function signOut() {
            appActivitySvc.busy("userSvc");
            var deferred = $q.defer();
            auth_factory
                .logout()
                .$promise
                .then(
                    function (result) {
                        $ocLazyLoad.load([
                            'https://apis.google.com/js/platform.js'
                        ]).then(function () {
                            gapi.load('auth2', function () {
                                var auth2 = gapi.auth2.getAuthInstance();
                                if (auth2)
                                    auth2.signOut().then(function () {
                                        auth2.disconnect();
                                    });
                            });
                        });
                        CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                        CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                        // Clear upcomingPayment cookie on logout
                        $rootScope.deleteUpcomingPaymentFromCookie();
                        window.endeksa = null;
                        service.setUser();
                        var stateKeys = ['tidio_state_PK', 'tidio_state_j5alrjdajkdksb5lhqle6ssooanm9dgf'];
                        stateKeys.forEach(function (stateKey) {
                            var state = JSON.parse(localStorage.getItem(stateKey));
                            if (state)
                                $window.localStorage.setItem(stateKey, JSON.stringify({}));
                        });
                        deferred.resolve(result);
                    },
                    function (reject) {
                        // reject.errors.map(function (error) {
                        //     notifierSvc.show({ message: error.Message, type: "error" });
                        // });
                        deferred.reject(reject);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            return deferred.promise;
        }

        function changePassword(args) {
            appActivitySvc.busy("userSvc");

            auth_factory
                .change_password(args)
                .$promise
                .then(
                    function (result) {
                        var changePwd = $translate.instant("change_pwd");
                        notifierSvc.show({ message: changePwd, type: "success" });
                        return result;
                    },
                    function (result) {
                        result.errors.map(function (error) {
                            notifierSvc.show({ message: error.Message, type: "error" });
                        });
                        return $q.reject(result);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
        }


        function changeUser() {
            var defer = $q.defer();
            appActivitySvc.busy("userSvc");
            loginChange().then(function () {
                ngDialog.close();
                user_factory
                    .me()
                    .$promise
                    .then(
                        function (result) {
                            service.lastResult = result;
                            $window.endeksa = {
                                id: result.information.id.value,
                                email: result.information.email,
                                phone: result.information.phoneNumber
                            };
                            service.setUser(result);
                            $window.userStorage.sync();
                            defer.resolve(result);
                            $window.location.reload();
                        },
                        function (result) {
                            $window.endeksa = null;
                            service.setUser();
                            defer.reject(result);
                        }
                    )["finally"](function () {
                        notopen = true;
                        appActivitySvc.idle("userSvc");
                    });
            }, function () {
                defer.reject();
                exitUser();
            });
            return defer.promise;
        }

        function setWithExpiry(key, value, ttl) {
            const now = new Date();

            // `item` is an object which contains the original value
            // as well as the time when it's supposed to expire
            const item = {
                value: value,
                expiry: now.getTime() + ttl,
            };
            localStorage.setItem(key, JSON.stringify(item));
        }
        function getWithExpiry(key) {
            const itemStr = localStorage.getItem(key);
            // if the item doesn't exist, return null
            if (!itemStr) {
                return null;
            }
            const item = JSON.parse(itemStr);
            const now = new Date();
            // compare the expiry time of the item with the current time
            if (now.getTime() > item.expiry) {
                // If the item is expired, delete the item from storage
                // and return null
                localStorage.removeItem(key);
                return null;
            }
            return item.value;
        }

        function getFinger() {
            var defer = $q.defer();
            const cacheKey = "__eVId__";
            const ttl = 24 * 60 * 60 * 1000; //24 hours
            const cachedFinger = getWithExpiry(cacheKey);
            if (!cachedFinger)
                if (window.isHeadless()) {
                    const code = "PRERENDER_" + window.makeid(10);
                    setWithExpiry(cacheKey, code, ttl);
                    defer.resolve(code);
                }
                else {
                    $ocLazyLoad.load([
                        'https://metrics.endeksa.com/web/v3/gU3h2z8EbwK2LC8xVW6H/umd.min.js'
                    ]).then(function () {
                        var fpPromise = FingerprintJS.load({
                            region: 'eu',
                            endpoint: ["https://metrics.endeksa.com", FingerprintJS.defaultEndpoint]
                        });

                        try {
                            fpPromise
                                .then(function (fp) { return fp.get(); }, function () {
                                    console.log('FP load error...');
                                    defer.resolve();
                                })
                                .then(function (result) {
                                    setWithExpiry(cacheKey, result.visitorId, ttl);
                                    defer.resolve(result.visitorId);
                                }, function () {
                                    console.log('FP load error...');
                                    defer.resolve();
                                });
                        } catch (error) {
                            console.log('FP load error...');
                            defer.resolve();
                        }
                    }, function () {
                        console.log('FP load error...');
                        defer.resolve();
                    });
                }
            else
                defer.resolve(cachedFinger);
            return defer.promise;
        }


        function getFingerLimit(page) {
            var defer = $q.defer();
            if (page) {
                service.finger_info.prints[page] = service.finger_info.prints[page] || {};
                if (!service.finger_info.prints[page].ip && !window.isHeadless())
                    getFinger().then(function (finger) {
                        if (finger) {
                            auth_factory.get_info_finger({ 'fingerPrint': finger, page: page }).$promise.then(
                                function (result) {
                                    if (result.length) {
                                        service.finger_info.prints[page] = result[0];
                                        if (service.finger_info.prints[page].limitReached) {
                                            $timeout(function () {
                                                $rootScope.$broadcast("finger_limit_reached", service.finger_info.prints[page]);
                                            }, 1500);
                                        }
                                    }
                                    else {
                                        service.finger_info.prints = {};
                                        service.finger_info.prints[page] = {};
                                        service.finger_info.prints[page].page = page;
                                        service.finger_info.prints[page].limitReached = false;
                                        notifierSvc.remove();
                                        notifierSvc.show({ message: $translate.instant('access_permitted'), type: "info" });
                                    }
                                    defer.resolve();
                                },
                                function () {
                                    defer.resolve();
                                });
                        }
                        else {
                            service.finger_info.prints[page].page = page;
                            service.finger_info.prints[page].limitReached = true;
                            $timeout(function () {
                                $rootScope.$broadcast("finger_limit_reached", service.finger_info.prints[page]);
                            }, 1500);
                            defer.resolve();
                        }
                    });
                else if (window.isHeadless())
                    defer.resolve();
                else {
                    if (service.finger_info.prints[page].limitReached) {
                        $timeout(function () {
                            $rootScope.$broadcast("finger_limit_reached", service.finger_info.prints[page]);
                        }, 1500);
                    }
                    defer.resolve();
                }
            }
            else {
                if (!Object.keys(service.finger_info.prints).length && !window.isHeadless())
                    getFinger().then(function (finger) {
                        if (finger) {
                            auth_factory.get_info_finger({ 'fingerPrint': finger }).$promise.then(
                                function (result) {
                                    if (result.length)
                                        result.forEach(function (m) {
                                            service.finger_info.prints[m.page] = m;
                                            if (service.finger_info.prints[m.page].limitReached) {
                                                $timeout(function () {
                                                    $rootScope.$broadcast("finger_limit_reached", service.finger_info.prints[m.page]);
                                                }, 1500);
                                            }
                                        });
                                    else {
                                        service.finger_info.prints = {};
                                        notifierSvc.remove();
                                        notifierSvc.show({ message: $translate.instant('access_permitted'), type: "info" });
                                    }
                                    defer.resolve();
                                },
                                function () {
                                    defer.resolve();
                                });
                        }
                        else {
                            service.finger_info.prints[page].page = page;
                            service.finger_info.prints[page].limitReached = true;
                            $timeout(function () {
                                $rootScope.$broadcast("finger_limit_reached", service.finger_info.prints[page]);
                            }, 1500);
                            defer.resolve();
                        }
                    });
                else {
                    defer.resolve();
                }
            }
            return defer.promise;
        }


        function setFingerLimit(page, maxFinger, maxIp) {
            var defer = $q.defer();
            service.finger_info.prints[page] = service.finger_info.prints[page] || {};
            if (!service.finger_info.prints[page].limitReached && !window.isHeadless())
                getFinger().then(function (finger) {
                    if (finger)
                        auth_factory.set_info_finger({ 'fingerPrint': finger, page: page, maxFingerPrint: maxFinger, maxIp: maxIp }).$promise.then(
                            function (result) {
                                service.finger_info.prints[page] = result;
                                if (service.finger_info.prints[page].limitReached) {
                                    $rootScope.$broadcast("finger_limit_reached", service.finger_info.prints[page]);
                                    defer.reject();
                                }
                                else
                                    defer.resolve();
                            },
                            function () {
                                defer.resolve();
                            });
                    else {
                        service.finger_info.prints[page].page = page;
                        service.finger_info.prints[page].limitReached = true;
                        $timeout(function () {
                            $rootScope.$broadcast("finger_limit_reached", service.finger_info.prints[page]);
                        }, 1500);
                        defer.reject();
                    }
                });
            else if (window.isHeadless())
                defer.resolve();
            else {
                $rootScope.$broadcast("finger_limit_reached", service.finger_info.prints[page]);
                defer.reject();
            }
            return defer.promise;
        }

        function loginControl() {
            var defer = $q.defer();
            getFinger().then(function (finger) {
                if (finger)
                    auth_factory.get_finger({ 'userfinger': finger }).$promise.then(
                        function (result) {
                            defer.resolve({
                                active: true,
                                data: result
                            });
                        },
                        function (result) {
                            defer.reject({
                                active: false,
                                data: result.data
                            });
                        });
                else
                    defer.resolve({
                        active: true,
                        data: null
                    });
            });
            return defer.promise;
        }

        function loginChange() {
            var defer = $q.defer();
            getFinger().then(function (finger) {
                if (finger)
                    auth_factory.set_finger({ 'userfinger': finger }).$promise.then(function (result) {
                        defer.resolve({
                            active: true,
                            data: result
                        });
                    }, function (result) {
                        defer.reject({
                            active: false,
                            data: result.data
                        });
                    });
                else
                    defer.resolve({
                        active: true,
                        data: null
                    });
            });
            return defer.promise;
        }
        var notopen2 = true;
        function exitUser() {
            ngDialog.close();
            if (notopen2) {
                notopen2 = false;
                ngDialog.open({
                    templateUrl: "app/shell/logincountmultiple.html",
                    controller: function () {
                    },
                    closeByNavigation: false,
                    closeByDocument: false,
                    closeByEscape: false,
                });
                if (service.lastResult) {
                    var title =
                        "Kullanıcının cihaz değişim hakkı bitti. Takip edilmesinde fayda olabilir.";
                    var content =
                        service.lastResult.information.profile.name +
                        " " +
                        service.lastResult.information.profile.surName +
                        " " +
                        service.lastResult.information.phoneNumber +
                        " " +
                        service.lastResult.information.email;
                    leadAPI.set({
                        Email: "satis@endeksa.com",
                        Source: "Potansiyel Kaçak Kullanım Tespiti",
                        Content: [{ Value: content, Title: title }],
                    });
                }
                $window.endeksa = null;
                service.setUser();
            }
        }


        var notopen = true;
        function checkUserIsAlive() {
            if (!notopen)
                return false;
            notopen = false;
            appActivitySvc.busy("userSvc");
            loginControl().then(function (result) {
                if (result.data.multipleUseDetected) {
                    ngDialog.open({
                        templateUrl: "app/shell/logincountexceeded.html",
                        controller: [
                            "$scope",
                            function ($scope) {
                                $scope.userAgent = result.data.sessions;
                                $scope.proceedLogout = changeUser;
                            },
                        ],
                        closeByNavigation: false,
                        closeByDocument: false,
                        closeByEscape: false,
                    });
                }
            }, function () {
                // exitUser(); //TODO: [EB-270] Finger control get ucunda bazı durumlarda 500 hatası alınıyor. İncelenmeli. Sistemin açılmasına izin vermiyor.
            })["finally"](function () {
                appActivitySvc.idle("userSvc");
            });
        }

        var getting_user = false;

        function getUserInfo(force, isLogin) {
            var defer = $q.defer();
            appActivitySvc.busy("userSvc");
            service.setGA4UserProperties();
            if (!$cookies.get('login_status'))
                $cookies.put('login_status', false);
            const token = $window.localStorage.getItem("refreshToken");
            if (!token || (window.isHeadless() && !$rootScope.clientData)) {
                defer.reject();
                appActivitySvc.idle("userSvc");
            }
            else if (service.lastResult && !force) {
                defer.resolve(service.lastResult);
                appActivitySvc.idle("userSvc");
            } else if (!getting_user || force) {
                getting_user = true;
                user_factory
                    .me()
                    .$promise
                    .then(
                        function (result) {
                            service.refreshClientId(result.information.googleClickId, result.information.googleClientId, result.information.googleSessionId, result.information.googleSessionNumber);
                            if (!window.refMobile && (!result.information.profile.userType ||
                                !result.information.profile.name ||
                                !result.information.profile.name.length ||
                                result.information.profile.name === 'Guest' ||
                                !result.information.profile.surName ||
                                !result.information.profile.surName.length ||
                                result.information.profile.surName === 'Apple' ||
                                result.information.permissions.indexOf(120) === -1 ||
                                result.information.permissions.indexOf(110) === -1 ||
                                result.information.permissions.indexOf(60) === -1 ||
                                result.information.permissions.indexOf(130) === -1 ||
                                result.information.permissions.indexOf(140) === -1)) {
                                $rootScope.unRegisteredUser = true;
                                $timeout(function () { selectUserType(); }, 2000);
                            }
                            service.lastResult = result;
                            $window.endeksa = {
                                id: result.information.id.value,
                                email: result.information.email,
                                phone: result.information.phoneNumber
                            };

                            $window.userStorage.sync();
                            service.setUser(result);
                            var check_finger = false;
                            var products = result.products.map(function (m) {
                                return m.code;
                            });
                            ['location-package', 'real-estate-package', 'platinum-package', 'eco-package', 'seller-lead-package', 'premium-package', 'premiumplus-package', 'personal-package', 'basic-package', 'pro-ee-package', 'flex-package', 'gold-package', 'terminal-flex-package', 'terminal-pro-package', 'premium-ee-package', 'terminal-premium-package'].forEach(function (product) {
                                if (products.includes(product)) {
                                    check_finger = true;
                                }
                            });
                            if (check_finger && !window.refMobile && !$rootScope.isTop)
                                checkUserIsAlive();

                            if (isLogin) {
                                const langIso = window.langIso(result.information.language);
                                window.dataLayer.push({
                                    event: "login",
                                    currency: window.currency,
                                    language: langIso,
                                    login: {
                                        method: "Form"
                                    }
                                });
                                if (langIso !== window.lang)
                                    window.localStorage.setItem('ChangeLanguage', langIso);
                                //check after transition and do the translation when everything is ready
                            }
                            $rootScope.recommendedFieldsToFill = result.information.recommendedFieldsToFill;
                            $rootScope.recommendedFieldsToFill.isAgent = result.isAgent;

                            // Handle MCP OAuth flow after successful getUserInfo
                            // Try to initialize OAuth params from URL or session storage
                            var oauthParams = mcpService.initializeOAuthParams();
                            if (oauthParams && Object.keys(oauthParams).length > 0) {
                                console.log('[SignIn] OAuth params detected, starting consent flow');
                                mcpService.handleOAuthConsentFlow(oauthParams, true)
                                    .then(
                                        function () {
                                            console.log('[SignIn] OAuth flow completed successfully');
                                        },
                                        function (error) {
                                            console.error('[SignIn] OAuth flow failed:', error);
                                        }
                                    );
                            }

                            defer.resolve(result);

                        },
                        function (rej) {
                            service.setUser();
                            $window.endeksa = null;
                            defer.reject(rej);
                        }
                    )["finally"](function () {
                        getting_user = false;
                        appActivitySvc.idle("userSvc");
                    });
            }
            else if (getting_user) {
                var interv = $interval(function () {
                    if (!getting_user) {
                        if (service.lastResult) {
                            defer.resolve(service.lastResult);
                            appActivitySvc.idle("userSvc");
                        }
                        else {
                            service.setUser();
                            $window.endeksa = null;
                            defer.reject();
                            appActivitySvc.idle("userSvc");
                        }
                        $interval.cancel(interv);
                    }
                });
            }
            return defer.promise;
        }

        // function addLocalLogin(data) {
        //     return setPassword(data);
        // }

        //register a new user and if the registration is successful signIn
        // function registerExternal(registration) {
        //     appActivitySvc.busy("userSvc");

        //     return accountClientSvc
        //         .registerExternal(registration)["finally"](function () {
        //             if (typeof $window.ga !== "undefined")
        //                 $timeout(function () {
        //                     $analytics.eventTrack("Registration Complete", {
        //                         category: "Registration",
        //                         label: "Registration Social Media",
        //                         nonInteraction: true,
        //                         page: $location.path(),
        //                     });
        //                     $window.gtag("event", "sign_up", { method: "External" });
        //                 }, 600);
        //             if (typeof $window.fbq !== "undefined")
        //                 $window.fbq("track", "CompleteRegistration");

        //             //try { $window.__adroll.record_user({ "adroll_segments": "z9oi8qg7" }) } catch (err) { }
        //             appActivitySvc.idle("userSvc");
        //         });
        // }

        function passwordStatus() {
            var deferred = $q.defer();
            if (document.cookie.indexOf('password_status') === -1) {
                var passStatus = user_factory.password_status();
                passStatus.$promise.then(function (response) {
                    var now = new Date();
                    var time = now.getTime();
                    var expireTime = time + 1000 * 60 * 60 * 24 * 5;
                    now.setTime(expireTime);
                    document.cookie = 'password_status=cached;expires=' + now.toUTCString() + ';path=/';
                    deferred.resolve(response);
                }, function (reject) {
                    deferred.reject(reject);
                });
            } else {
                deferred.resolve({ expiredStatus: false });
            }
            return deferred.promise;
        }

        function register(registration) {
            var deferred = $q.defer();
            appActivitySvc.busy("userSvc");
            //grecaptcha.ready(function () {
            //grecaptcha.execute('6LdqE04cAAAAADAoSM5v54W0wLw6XRQvnaU9tgVS', { action: 'submit' }).then(function (token) {
            //registration.captchaToken = token;
            registration.RefUrl = window.referrer;
            registration.googleClickId = window.gclid;
            registration.googleClientId = window.gaclient;
            registration.googleSessionId = window.gasessionId;
            registration.googleSessionNumber = window.gasessionNumber;
            registration.captchaTokenCustom = window.ecSec();
            restoreUrlService.getLastState().then(function (res) {
                if (res && res.lastState && res.lastState.indexOf('valuation') > -1)
                    registration.RefFunc = 10;
                else if (res && res.lastState && res.lastState.indexOf('cozumler') > -1)
                    registration.RefFunc = 20;
                else if (res && res.lastState && res.lastState.indexOf('hizmetler') > -1)
                    registration.RefFunc = 30;
                else if (res && res.lastState && res.lastState.indexOf('analysis') > -1)
                    registration.RefFunc = 40;
                else
                    registration.RefFunc = 0;
            });
            user_factory
                .create(registration)
                .$promise
                .then(function (result) {
                    window.dataLayer.push({
                        event: "sign_up",
                        currency: window.currency,
                        language: window.lang.split('-')[0],
                        // referrer: window.referrer,
                        // gclid: window.gclid,
                        // visitorReason: registration.RegisterReason,
                        // referencePage: registration.RefFunc,
                        // visitorType: registration.userType,
                        login: {
                            method: "Form"
                        }
                    });
                    if (typeof $window.fbq !== "undefined") {
                        $window.fbq('track', 'Lead');
                        $window.fbq("track", "CompleteRegistration");
                    }
                    deferred.resolve(result);
                }, function (reject) {
                    deferred.reject(reject);
                })["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            //});
            //});

            return deferred.promise;
        }

        function refresh() {
            var deferred = $q.defer();
            appActivitySvc.busy("userSvc");

            const token = $window.localStorage.getItem("accessToken");
            const expire = $window.localStorage.getItem("accessTokenExpires");
            const refreshToken = $window.localStorage.getItem("refreshToken");
            const refreshTokenExpires = $window.localStorage.getItem("refreshTokenExpires");
            if (refreshToken && refreshTokenExpires && token && expire && !window.isHeadless())
                auth_factory
                    .refresh({ accessToken: token, refreshToken: refreshToken, accessTokenExpiration: expire, refreshTokenExpiration: refreshTokenExpires })
                    .$promise
                    .then(
                        function (result) {
                            deferred.resolve(result);
                        },
                        function (reject) {
                            deferred.reject(reject);
                        }
                    )["finally"](function () {
                        appActivitySvc.idle("userSvc");
                    });
            else {
                appActivitySvc.idle("userSvc");
                deferred.reject();
            }
            return deferred.promise;
        }

        function signInExternal(data) {
            data.language = $window.langCode();
            appActivitySvc.busy("userSvc");
            var deferred = $q.defer();
            auth_factory
                .verify_token(data)
                .$promise
                .then(
                    function (result) {
                        if (result && result.accessToken) {

                            $window.localStorage.setItem("accessToken", result.accessToken);
                            $window.localStorage.setItem("accessTokenExpires", result.accessTokenExpiration);
                            $window.localStorage.setItem("refreshToken", result.refreshToken);
                            $window.localStorage.setItem("refreshTokenExpires", result.refreshTokenExpiration);
                            getUserInfo(null, true).then(function () {
                                deferred.resolve(result);
                            }, function (reject) {
                                notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "warning" });
                                deferred.reject(reject);
                            });
                        } else {
                            deferred.reject();
                        }
                    },
                    function (reject) {
                        notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "warning" });
                        deferred.reject(reject);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            return deferred.promise;
        }

        function signInEmlakjet(tokenData) {
            appActivitySvc.busy("userSvc");
            var deferred = $q.defer();

            if (tokenData && tokenData.accessToken) {
                $window.localStorage.setItem("accessToken", tokenData.accessToken);
                $window.localStorage.setItem("accessTokenExpires", tokenData.accessTokenExpiration);
                $window.localStorage.setItem("refreshToken", tokenData.refreshToken);
                $window.localStorage.setItem("refreshTokenExpires", tokenData.refreshTokenExpiration);

                getUserInfo(null, true).then(
                    function () {
                        appActivitySvc.idle("userSvc");
                        deferred.resolve(tokenData);
                    },
                    function (reject) {
                        appActivitySvc.idle("userSvc");
                        notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "warning" });
                        deferred.reject(reject);
                    }
                );
            } else {
                appActivitySvc.idle("userSvc");
                deferred.reject({ error: 'invalid_token', message: 'Token bilgisi eksik' });
            }
            return deferred.promise;
        }

        function externalLoginConfirm(data) {
            var request = {
                provider: data.provider,
                token: data.token,
                email: data.email || null
            };
            appActivitySvc.busy("userSvc");
            var deferred = $q.defer();
            auth_factory
                .external_login_confirm(request)
                .$promise
                .then(
                    function (result) {
                        deferred.resolve(result.isRequired === true);
                    },
                    function (reject) {
                        notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "warning" });
                        deferred.reject(reject);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            return deferred.promise;
        }


        function SendConfirmationEmail(email, token) {
            var defer = $q.defer();
            appActivitySvc.busy("userSvc");
            auth_factory
                .get_confirm({ email: email, language: $window.langCode(), captchaToken: token })
                .$promise
                .then(
                    function (result) {
                        defer.resolve(result);
                    },
                    function (reject) {
                        notifierSvc.show({ message: reject.data.detail ? reject.data.detail : reject.data.title, type: "error" });
                        defer.reject(reject);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });

            return defer.promise;
        }

        function ConfirmEmail(data) {
            var defer = $q.defer();
            appActivitySvc.busy("userSvc");
            auth_factory
                .set_confirm(data)
                .$promise
                .then(
                    function (result) {
                        defer.resolve(result);
                    },
                    function (reject) {
                        notifierSvc.show({ message: reject.data.detail, type: "error" });
                        // var storedLang =
                        //     $window.lang || "tr";
                        // $state.go("confirmEmail", { langcode: storedLang });

                        defer.reject(reject);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            return defer.promise;
        }

        function SendForgotPasswordEmail(email) {
            var defer = $q.defer();
            appActivitySvc.busy("userSvc");
            auth_factory
                .forgot_password({ email: email })
                .$promise
                .then(
                    function (result) {
                        defer.resolve(result);
                    },
                    function (result) {
                        notifierSvc.show({ message: result.data.detail, type: "error" });
                        defer.reject(result);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            return defer.promise;
        }

        function ResetPassword(Email, Password, Token, Key) {
            var defer = $q.defer();
            appActivitySvc.busy("userSvc");
            auth_factory
                .change_password({ email: Email, password: Password, token: Token, userId: Key })
                .$promise
                .then(
                    function (result) {
                        $window.location.href =
                            "/" + $rootScope.lang + "/signin?status=reset";
                        defer.resolve(result);
                    },
                    function (result) {
                        notifierSvc.show({ message: result.data.detail, type: "error" });
                        defer.reject(result);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            return defer.promise;
        }

        function NewPassword(Email, Password, Token, Key) {
            var defer = $q.defer();
            appActivitySvc.busy("userSvc");
            auth_factory
                .change_password({ email: Email, password: Password, token: Token, userId: Key })
                .$promise
                .then(
                    function (result) {
                        defer.resolve(result);
                    },
                    function (result) {
                        notifierSvc.show({ message: result.data.detail, type: "error" });
                        defer.reject(result);
                    }
                )["finally"](function () {
                    appActivitySvc.idle("userSvc");
                });
            return defer.promise;
        }

        function raiseEvent() {
            $rootScope.$broadcast("userSvc:signedInChanged", {
                SignedIn: service.info.SignedIn,
            });
            $rootScope.SignedIn = service.info.SignedIn;
        }
        var userSelectDialog;
        function selectUserType() {
            if (!userSelectDialog)
                userSelectDialog = ngDialog.open({
                    templateUrl: "app/security/complete-account.modal.html",
                    controller: selectUserTypeController,
                    closeByEscape: false,
                    className: "ngdialog-theme-default on-top",
                });

            selectUserTypeController.$inject = [
                "$scope",
                "$rootScope",
                "notifierSvc",
                "$translate",
                "geoApi",
                "provinceListService",
                "$timeout"
            ];

            function selectUserTypeController($scope, $rootScope, notifierSvc, $translate, geoApi, provinceListService, $timeout) {
                $scope.phoneVisible = false;
                if (!window.libphonenumber) {
                    $ocLazyLoad.load([
                        "/assets/js/vendor.phone.min.js?v=" + ($window.appVersion || Date.now())
                    ]).then(function () {
                        $scope.phoneVisible = true;
                    }, function () {
                        $scope.phoneVisible = false;
                    });
                } else {
                    $scope.phoneVisible = true;
                }
                $scope.updateMyProfile = updateMyProfile;
                $scope.userData = angular.copy(service.info);
                $scope.hasMail = $scope.userData.Details.email !== '' && $scope.userData.Details.email !== null;
                $scope.hasPhone = $scope.userData.Details.phoneNumber !== '' && $scope.userData.Details.phoneNumber !== null;
                if (!$scope.userData.Details.permissions.includes(40))
                    $scope.userData.Details.permissions.push(40);
                if (!$scope.userData.Details.permissions.includes(30))
                    $scope.userData.Details.permissions.push(30);
                $scope.userData.Details.canReceiveSystemNotification = true;
                $scope.userData.Details.canReceiveRealEstateNotification = true;

                $scope.userData.Details.profile.userType = $scope.userData.Details.profile.userType || 10;

                if ($scope.userData.Details.profile.name === 'Guest') {
                    $scope.userData.Details.profile.name = "";
                }
                if ($scope.userData.Details.profile.surName === 'Apple')
                    $scope.userData.Details.profile.surName = "";

                geoApi.getCountries({ language: window.langCode() }).$promise.then(function (result) {
                    $scope.nationality = result;
                    let code;
                    switch ($rootScope.country) {
                        case 'world':
                            code = 826;
                            break;
                        case 'turkiye':
                            code = 792;
                            break;
                        case 'espana':
                            code = 724;
                            break;
                        case 'portugal':
                            code = 620;
                            break;
                        default:
                            code = 792;
                    }
                    $scope.selectedCountry = result.find(c => c.CountryCode === code);
                    $scope.getCities();
                });

                $scope.getCities = function () {
                    let nationality;
                    switch ($scope.selectedCountry.CountryCode) {
                        case 792:
                            nationality = 1;
                            break;
                        case 724:
                            nationality = 2;
                            break;
                        case 620:
                            nationality = 3;
                            break;
                        default:
                            $scope.userCities = null;
                            $scope.selectedCity = null;
                            return;
                    }
                    provinceListService.getProvinces(nationality).then(function (response) {
                        $scope.userCities = response.List;
                        $scope.selectedCity = {};
                    });
                };


                $scope.mailValidation = {
                    valid: true,
                    registered: false,
                    changed: false,
                    waitingOtp: false
                };

                $scope.phoneValidation = {
                    valid: true,
                    registered: false,
                    changed: false,
                    waitingOtp: false
                };

                // Captcha state
                $scope.ETToken = null;
                $scope.captchaVerified = false;
                $scope.isTurkishPhone = true;
                $scope.eimageCaptchaKey = null;
                $scope.eimageCaptchaValue = null;

                $timeout(function () {
                    $scope.mailValidation.changed = false;
                    $scope.phoneValidation.changed = false;
                }, 1000);

                // $scope.sozlesmeKabul = $scope.userData.Details.permissions.indexOf(130) > -1;
                // $scope.gizlilikKabul = $scope.userData.Details.permissions.indexOf(110) > -1;
                // $scope.kisiselveriKabul = $scope.userData.Details.permissions.indexOf(140) > -1;

                function updateMyProfile(form) {
                    if (form.$valid && $scope.userData.Details.profile.userType && $scope.userData.Details.profile.name && $scope.userData.Details.profile.surName) {
                        if (!$scope.userData.Details.phoneNumber)
                            $scope.userData.Details.phoneNumber = null;
                        if ($scope.userData.Details.phoneNumber) {
                            $scope.userData.Details.phoneNumber = $scope.userData.Details.phoneNumber.replace(/\s+/g, '');
                        }
                        $scope.loading = true;
                        $scope.userData.Details.profile.lang = $rootScope.lang;
                        if ($scope.userData.Details.registerReason === 10 && $scope.userData.Details.contactAccepted) {
                            $scope.userData.Details.permissions.push(150, 160);
                        }
                        $scope.userData.Details.RefUrl = window.referrer;
                        restoreUrlService.getLastState().then(function (res) {
                            if (res && res.lastState && res.lastState.indexOf('valuation') > -1)
                                $scope.userData.Details.RefFunc = 10;
                            else if (res && res.lastState && res.lastState.indexOf('cozumler') > -1 || res && res.lastState && res.lastState.indexOf('solutions') > -1)
                                $scope.userData.Details.RefFunc = 20;
                            else if (res && res.lastState && res.lastState.indexOf('hizmetler') > -1 || res && res.lastState && res.lastState.indexOf('services') > -1)
                                $scope.userData.Details.RefFunc = 30;
                            else if (res && res.lastState && res.lastState.indexOf('analiz') > -1)
                                $scope.userData.Details.RefFunc = 40;
                            else
                                $scope.userData.Details.RefFunc = 0;
                        });
                        $scope.userData.Details.CountryId = $scope.userData.Details.countryId ? $scope.userData.Details.countryId : ($scope.selectedCountry.CountryId ? $scope.selectedCountry.CountryId : $scope.selectedCountry.CountryCode);
                        $scope.userData.Details.CountryName = $scope.userData.Details.countryName ? $scope.userData.Details.countryName : $scope.selectedCountry.CountryName;
                        $scope.userData.Details.CityId = $scope.userData.Details.cityId ? $scope.userData.Details.cityId : ($scope.selectedCity && $scope.selectedCity.hasOwnProperty('CityId') ? $scope.selectedCity.cityId : null);
                        $scope.userData.Details.CityName = $scope.userData.Details.cityName ? $scope.userData.Details.cityName : ($scope.selectedCity && $scope.selectedCity.hasOwnProperty('CityName') ? $scope.selectedCity.CityName : null);
                        $rootScope.unRegisteredUser = false;
                        if ($scope.userData.Details.permissions.indexOf(60) === -1) $scope.userData.Details.permissions.push(60);
                        if ($scope.userData.Details.permissions.indexOf(110) === -1) $scope.userData.Details.permissions.push(110);
                        if ($scope.userData.Details.permissions.indexOf(120) === -1) $scope.userData.Details.permissions.push(120);
                        if ($scope.userData.Details.permissions.indexOf(130) === -1) $scope.userData.Details.permissions.push(130);
                        if ($scope.userData.Details.permissions.indexOf(140) === -1) $scope.userData.Details.permissions.push(140);
                        user_factory.update($scope.userData.Details).$promise.then(
                            function (result) {
                                window.dataLayer.push({
                                    event: "sign_up",
                                    currency: window.currency,
                                    language: window.lang.split('-')[0],
                                    // referrer: window.referrer,
                                    // gclid: window.gclid,
                                    // visitorReason: $scope.userData.Details.registerReason,
                                    // referencePage: $scope.userData.Details.profile.RefFunc,
                                    // visitorType: $scope.userData.Details.profile.userType,
                                    login: {
                                        method: "External"
                                    }
                                });
                                CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                                CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                                $scope.userData.Details.profile.lastModifiedDate = result.lastModifiedDate;
                                getUserInfo(true, true).then(function () {
                                    $scope.loading = false;
                                    $scope.closeThisDialog();
                                }, function () {
                                    $scope.loading = false;
                                    var updateProfile2 = $translate.instant("update_myprofile2");
                                    notifierSvc.show({ message: updateProfile2, type: "error" });
                                });
                            },
                            function (err) {
                                $scope.loading = false;
                                if (err.data.detail.includes("updated with newer")) {
                                    notifierSvc.show({ message: $translate.instant('account_update_error'), type: "error" });
                                } else {
                                    var updateProfile2 = $translate.instant("update_myprofile2");
                                    notifierSvc.show({ message: updateProfile2, type: "error" });
                                }
                            }
                        );

                    } else {
                        $scope.formValid = false;
                    }
                }

                $scope.changePermission = (event, val) => {
                    if (event) {
                        $scope.userData.Details.permissions.push(val);
                    } else {
                        const index = $scope.userData.Details.permissions.indexOf(val);
                        $scope.userData.Details.permissions.splice(index, 1);
                    }
                };

                $scope.termsModal = function () {
                    ngDialog.open({
                        templateUrl: 'app/content/sozlesme/' + window.lang + '/kullanim.html',
                        controller: ['$scope', ($scope) => {
                            $scope.onModal = true;
                        }]
                    });
                };

                $scope.gizlilikModal = function () {
                    ngDialog.open({
                        templateUrl: 'app/content/sozlesme/' + window.lang + '/gizlilik.html',
                        controller: ['$scope', ($scope) => {
                            $scope.onModal = true;
                        }]
                    });
                };


            }
        }
        return service;
    }
})();
